import pigeon from '../../utilities/js/pigeon/pigeon.js';

export default class Address {
  constructor(mainElement, name = 'address') {
    const editAddressButton = mainElement.querySelector(`.${name}__button--edit`);
    editAddressButton?.addEventListener('click', () => {
      pigeon.publish('addressChangeRequest', editAddressButton.dataset.id);
    });
  }
}
